import { BACKEND_URL } from '../../../util/api'
import Globals from '../../globals'

const getEndpoint = (customerId) => {
    return BACKEND_URL + '/api/customer/add-cbct-file?customerId=' + customerId || ''
}

function uploadChunk (fileListChunk, endpoint) {
    let chunkPromises = []
    for (let index = 0; index < fileListChunk.length; index++) {
        const file = fileListChunk[index]
        const data = new FormData()
        data.append('file', file)

        const filePromise = new Promise((resolve, reject) => {
            fetch(endpoint, {
                method: 'post',
                body: data,
                headers: {
                    Accept: 'application/json',
                },
                credentials: 'include',
            }).then(response => {
                try {
                    resolve(response.json())
                } catch (e) {
                    reject('Invalid json response')
                }
            }).catch(error => {
                reject(error)
            })
        })

        chunkPromises.push(filePromise)
    }
    return chunkPromises
}

export default async function uploadByChunks (customerId, fileList, fileType, onUploadSuccess, state) {
    const endpoint = getEndpoint(customerId)
    const chunkSize = 5
    const fileListLength = fileList.length

    for (let i = 0; i < fileListLength; i += chunkSize) {
        const fileListChunk = fileList.slice(i, i + chunkSize)

        const chunkPromises = uploadChunk(fileListChunk, endpoint)

        const isSuccess = await Promise.all(chunkPromises)
            .then((fileMetadataList) => {
                fileMetadataList.forEach((fileMetadata) => {
                    fileMetadata.createdByUser = Globals.selector.selectUserDisplayNameById(state, fileMetadata.createdByUserId)
                    onUploadSuccess(fileType, fileMetadata)
                })
                return true
            })
            .catch(() => {
                alert('Something went wrong. Please refresh the page and try to upload once again or contact a system administrator')
                return false
            })

        if (!isSuccess) {
            return false
        }
    }

    return true
}



// WEBPACK FOOTER //
// ./src/modules/customer/util/cbct-file-upload-helper.js